<div class="avatar-container">
  <ng-container *ngIf="user">
    <p-avatar
      *ngIf="file?.path; else defaultImage"
      [image]="file | fileUrl | apiUrl"
      [shape]="shape"
      [size]="size">
    </p-avatar>

    <ng-template #defaultImage>
      <p-avatar
        [size]="size"
        [shape]="shape"
        [label]="userLabel"
        [style]="{ backgroundColor: backgroundColor, color: colorService.setColorText(backgroundColor) }">
      </p-avatar>
    </ng-template>
  </ng-container>

  <div
    *ngIf="showAdminIcon"
    class="admin-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round">
      <path
        stroke="none"
        d="M0 0h24v24H0z"
        fill="none" />
      <path d="M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z" />
    </svg>
  </div>
</div>
